import {createRouter, createWebHistory} from 'vue-router'
import authView from "@/views/AuthView.vue";
import {useAuth0} from "@auth0/auth0-vue";
import OrderView from "@/views/OrderView.vue";
import OrderHistoryView from "@/views/OrderHistoryView.vue";
import OrderDetailView from "@/views/OrderDetailView.vue";
import OrderCreatedView from "@/views/OrderCreatedView.vue";
import {useAppStore} from "@/stores/appStore";

function hasCompletedRegistration(appStore: ReturnType<typeof useAppStore>): boolean {
    const customer = appStore.customer;
    if (!appStore.selectedProject || !customer) {
        return false;
    }

    return Boolean(customer.addresses?.shipping && customer.addresses?.billing);
}

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'auth',
            component: authView
        },
        {
            path: '/order',
            name: 'order',
            component: OrderView,
            meta: {
                requiresCompletedRegistration: true,
            }
        },
        {
            path: '/order-history',
            name: 'order-history',
            component: OrderHistoryView,
            meta: {
                requiresCompletedRegistration: true,
            }
        },
        {
            path: '/order/created/:orderId',
            name: 'order-created',
            component: OrderCreatedView,
            meta: {
                requiresCompletedRegistration: true,
            }
        },
        {
            path: '/order/:orderId',
            name: 'order-detail',
            component: OrderDetailView,
            meta: {
                requiresCompletedRegistration: true,
            }
        },
        {
            path: '/:pathMatch(.*)*',
            component: authView
        }
    ]
})

router.beforeEach((to, from, next) => {
    const {isAuthenticated, loginWithRedirect} = useAuth0();
    const appStore = useAppStore();
    const requiresCompletedRegistration = Boolean(to.meta.requiresCompletedRegistration);

    if (!isAuthenticated.value && to.name !== 'auth') {
        loginWithRedirect();
        next(false);
        return;
    }

    if (requiresCompletedRegistration && !hasCompletedRegistration(appStore)) {
        next({name: 'auth'});
        return;
    }

    next();
})

export default router
